import { render, staticRenderFns } from "./contentPetSymptoms.vue?vue&type=template&id=3db2957c&scoped=true"
import script from "./contentPetSymptoms.vue?vue&type=script&lang=js"
export * from "./contentPetSymptoms.vue?vue&type=script&lang=js"
import style0 from "./contentPetSymptoms.vue?vue&type=style&index=0&id=3db2957c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db2957c",
  null
  
)

export default component.exports